import SiteNav from './SiteNav';
import Footer from './Footer';
import { useLanguage } from './LanguageContext';
import './App.css';

function PrivacyEN() {
  return (
    <>
      <h1 className="legal-page-title">Cookie Policy &amp; GDPR</h1>
      <p className="legal-page-updated">Last updated: August 9, 2026</p>

      <h2>1. What are cookies?</h2>
      <p>
        Cookies are small text files stored on your device when you visit
        our website. They enable proper website functionality, remember
        your preferences, and help improve the quality of our services.
      </p>

      <h2>2. What cookies do we use?</h2>
      <p>
        <strong>Essential cookies</strong> — enable core functionality such
        as page navigation and access to secure areas.
      </p>
      <p>
        <strong>Functional cookies</strong> — remember your settings, such
        as language or region.
      </p>
      <p>
        <strong>Analytics cookies</strong> — collect anonymous statistics
        about how users interact with our website (e.g., Google Analytics).
      </p>
      <p>
        <strong>Marketing cookies</strong> — allow displaying personalized
        advertisements (set by us or third parties like Google, Meta).
      </p>

      <h2>3. Consent and management</h2>
      <p>
        Essential cookies are always enabled. Analytics and marketing
        cookies require your consent, which can be managed through the
        cookie banner displayed during your first visit. You can also
        change your browser&rsquo;s cookie settings at any time.
      </p>

      <h2>4. Third parties</h2>
      <p>
        Some cookies come from third-party providers: Google Cookies, Meta
        Cookies. Each third party processes data in accordance with its own
        privacy policy.
      </p>

      <h2>5. GDPR — Personal data processing</h2>
      <p>Personal data processed via cookies is used for:</p>
      <ul>
        <li>ensuring website functionality (essential cookies),</li>
        <li>analyzing traffic and statistics (analytics cookies),</li>
        <li>personalized marketing (marketing cookies).</li>
      </ul>
      <p>Legal basis: user consent (Article 6(1)(a) GDPR).</p>

      <h3>Your rights</h3>
      <ul>
        <li>access and rectification of data,</li>
        <li>withdraw consent at any time,</li>
        <li>request deletion or restriction,</li>
        <li>data portability,</li>
        <li>lodge a complaint with the supervisory authority.</li>
      </ul>

      <h2>6. Data retention</h2>
      <p>
        Cookies are stored according to file settings or until consent is
        withdrawn.
      </p>

      <h2>7. Data controller and contact</h2>
      <p>The data controller is:</p>
      <p>
        Name: PMind Piotr Szkałuba
        <br />
        Address: Tadeusza Kościuszki 59/10, 23-400 Biłgoraj
        <br />
        Email: info@pmind.eu
      </p>

      <h2>8. Changes</h2>
      <p>
        This Cookie Policy &amp; GDPR notice may be updated periodically. We
        encourage you to review it regularly.
      </p>
    </>
  );
}

function PrivacyPL() {
  return (
    <>
      <h1 className="legal-page-title">Polityka Cookies i RODO</h1>
      <p className="legal-page-updated">
        Ostatnia aktualizacja: 9 sierpnia, 2026 r.
      </p>

      <h2>1. Czym są pliki cookies</h2>
      <p>
        Pliki cookies to małe pliki tekstowe zapisywane na Twoim urządzeniu
        podczas odwiedzania naszej strony internetowej. Umożliwiają
        prawidłowe działanie strony, pamiętanie Twoich preferencji i poprawę
        jakości usług.
      </p>

      <h2>2. Jakie pliki cookies wykorzystujemy</h2>
      <p>
        <strong>Niezbędne cookies</strong> — pozwalają korzystać z
        podstawowych funkcji strony (np. nawigacja, logowanie).
      </p>
      <p>
        <strong>Funkcjonalne cookies</strong> — zapamiętują Twoje ustawienia,
        np. język czy region.
      </p>
      <p>
        <strong>Analityczne cookies</strong> — zbierają anonimowe informacje
        o sposobie korzystania ze strony (np. Google Analytics).
      </p>
      <p>
        <strong>Marketingowe cookies</strong> — umożliwiają wyświetlanie
        reklam dopasowanych do Twoich zainteresowań (mogą być ustawiane
        przez nas lub podmioty zewnętrzne, np. Google, Meta).
      </p>

      <h2>3. Zgoda i zarządzanie cookies</h2>
      <p>
        Niezbędne cookies są zawsze włączone. Analityczne i marketingowe
        cookies wymagają Twojej zgody, którą możesz wyrazić lub odmówić w
        banerze cookies wyświetlanym przy pierwszej wizycie. Możesz także
        zmienić ustawienia cookies w swojej przeglądarce w dowolnym
        momencie.
      </p>

      <h2>4. Podmioty zewnętrzne</h2>
      <p>
        Niektóre cookies pochodzą od podmiotów zewnętrznych: Google Cookies,
        Meta Cookies. Każdy z tych podmiotów może przetwarzać dane zgodnie
        ze swoją polityką prywatności.
      </p>

      <h2>5. RODO – przetwarzanie danych osobowych</h2>
      <p>
        Dane osobowe przetwarzane za pomocą plików cookies są używane w
        celu:
      </p>
      <ul>
        <li>poprawnego działania strony (niezbędne cookies),</li>
        <li>analizy ruchu i statystyk (analityczne cookies),</li>
        <li>marketingu i reklam spersonalizowanych (marketingowe cookies).</li>
      </ul>
      <p>Podstawa prawna: zgoda użytkownika (art. 6 ust. 1 lit. a RODO).</p>

      <h3>Twoje prawa</h3>
      <ul>
        <li>dostępu do swoich danych i ich sprostowania,</li>
        <li>cofnięcia zgody w dowolnym momencie,</li>
        <li>żądania usunięcia lub ograniczenia przetwarzania danych,</li>
        <li>przeniesienia danych,</li>
        <li>wniesienia skargi do Prezesa UODO.</li>
      </ul>

      <h2>6. Okres przechowywania danych</h2>
      <p>
        Cookies są przechowywane zgodnie z ustawieniami w plikach lub do
        momentu cofnięcia zgody.
      </p>

      <h2>7. Administrator danych i kontakt</h2>
      <p>Administratorem danych osobowych jest:</p>
      <p>
        Nazwa: PMind Piotr Szkałuba
        <br />
        Adres: Tadeusza Kościuszki 59/10, 23-400 Biłgoraj
        <br />
        Email: info@pmind.eu
      </p>

      <h2>8. Zmiany w polityce</h2>
      <p>
        Polityka cookies i RODO może być aktualizowana. Zachęcamy do
        okresowego zapoznawania się z jej treścią.
      </p>
    </>
  );
}

export default function Privacy() {
  const { lang } = useLanguage();

  return (
    <div className="simple-page">
      <SiteNav />

      <div className="legal-page">
        {lang === 'PL' ? <PrivacyPL /> : <PrivacyEN />}
      </div>

      <Footer />
    </div>
  );
}